import {css} from 'lit';
export const styles = css`:host {
  display: block;
}

header {
  margin-bottom: 16px;
}

.filters {
  margin-bottom: 8px;
}

button {
  all: unset;
  background: none;
  border: none;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  cursor: pointer;
  position: relative;
}

button span {
    text-decoration: underline;
  }

button:first-child {
  margin-right: 8px;
  border-right: 1px solid var(--gray-600);
  padding-right: 8px;
}

button:disabled {
  cursor: default;
  color: var(--secondary-500);
}

button:disabled span {
    text-decoration: none;
  }
`;
export default styles;
